import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FrameComponent } from './core/components/frame/frame.component';
import { SharelockCommonModule } from './share/modules/sharelock-common.module';

@Component({
  selector: 'shrl-root',
  imports: [SharelockCommonModule, FrameComponent],
  templateUrl: './shrl.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './shrl.component.scss',
})
export class ShrlComponent {}
